<template>
  <div class="ai-help-container">
    <!-- 顶部导航栏 -->
    <!-- <header class="ai-header">
      <div class="container">
        <div class="header-left">
          <img src="../../assets/back.png" alt="返回" class="back-icon">
          <h1 class="header-title">AI助手</h1>
        </div>
        <div class="header-right">
          <img src="../../assets/user_def.png" alt="用户头像" class="user-avatar">
        </div>
      </div>
    </header> -->

    <!-- 欢迎区域 -->
    <div class="container">
      <div class="welcome-section">
        <img src="../../assets/ai/ml.png" alt="AI助手头像" class="ai-avatar">
        <div class="welcome-text">
          <h2 class="ai-name">哈喽，我是AI助手小米粒</h2>
          <p class="ai-desc">小米粒已准备就绪，随时帮您解疑答惑，扩展思维</p>
        </div>
      </div>

      <!-- 主要功能区域 -->
      <div class="main-functions">
        <div class="function-card bg-green">
          <img src="../../assets/aiicon/aicon (20).png" alt="自由对话" class="function-icon">
          <h3 class="function-title">自由对话</h3>
          <p class="function-desc">随时交流，开启智慧对话</p>
          <button @click="toCoze('7594294549787688970')" class="start-btn">开始对话</button>
          <div class="times">1点/次会话</div>
        </div>
        <div class="function-card bg-blue row" @click="toCoze('7594354529966637065')">
          <img src="../../assets/aiicon/aicon (22).png" alt="图片生成观察记录" class="function-icon">
          <div>
            <h3 class="function-title">图片生成观察记录</h3>
            <p class="function-desc">生成观察要点建议等内容</p>
          </div>
          
          <div class="times">1点/次会话</div>
        </div>
        <div class="function-card bg-green-light row" @click="toCoze('7593236004942053412')">
          <img src="../../assets/aiicon/aicon (21).png" alt="图片生成" class="function-icon">
          <div>
            <h3 class="function-title">图片生成</h3>
            <p class="function-desc">根据文字描述生成图片</p>
          </div>
          
          <div class="times">1点/次会话</div>
        </div>
        <div class="function-card bg-fense" @click="toCoze('7594365337219432454')">
          <img src="../../assets/aiicon/aicon (23).png" alt="扩写润色" class="function-icon">
          <h3 class="function-title">扩写润色</h3>
          <p class="function-desc">轻松提升文稿质感</p>
          <div class="times">1点/次会话</div>
        </div>
        
      </div>

      <!-- 推荐区域 -->
      <div class="recommend-section">
        <div class="nav-tabs">
          <div @click="activeTab = -1" class="tab-item" :class="{'active': activeTab === -1}">推荐</div>
          <div @click="activeTab = index" class="tab-item" v-for="(item, index) in classList" :key="index" :class="{'active': activeTab === index}">{{item.name}}</div>    
          <!-- <div @click="activeTab = 2" class="tab-item" :class="{'active': activeTab === 2}">活动方案</div>
          <div @click="activeTab = 3" class="tab-item" :class="{'active': activeTab === 3}">成长报告</div>
          <div @click="activeTab = 4" class="tab-item" :class="{'active': activeTab === 4}">教案撰写</div>
          <div @click="activeTab = 5" class="tab-item" :class="{'active': activeTab === 5}">育儿分享</div>
          <div @click="activeTab = 6" class="tab-item" :class="{'active': activeTab === 6}">其他助手</div> -->
        </div>
        <div class="search-box">
          <input type="text" v-model="searchText" @input="searchAI" placeholder="搜索智能体" />
        </div>
      </div>
      </div>

      <!-- 分类功能区域 -->
      <!-- <div class="category-section">
        <h2 class="category-title blue">推荐</h2>
        <div class="category-cards">
          <div class="category-card bg-blue">
            <img src="../../assets/aiicon/aicon (25).png" alt="观察实录范例" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">观察实录范例</h3>
              <p class="card-desc">基于观察场景，撰写观察实录参考范例</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-blue">
            <img src="../../assets/aiicon/aicon (34).png" alt="观察记录专家点评" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">观察记录专家点评</h3>
              <p class="card-desc">基于记录内容，提供专家点评意见或润色后全文</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-green">
            <img src="../../assets/aiicon/aicon (20).png" alt="家长沟通话术" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">家长沟通话术</h3>
              <p class="card-desc">根据幼儿情况生成给家长的沟通话术</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-green-light">
            <img src="../../assets/aiicon/aicon (40).png" alt="教案大纲" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">教案大纲</h3>
              <p class="card-desc">根据主题、领域等要求生成教案大纲</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-green-light">
            <img src="../../assets/aiicon/aicon (44).png" alt="绘本图生成器" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">绘本图生成器</h3>
              <p class="card-desc">AI生成童趣绘本图，让故事更生动</p>
              <div class="times">5点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-blue-light">
            <img src="../../assets/aiicon/aicon (47).png" alt="月计划" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">月计划</h3>
              <p class="card-desc">一键生成月计划，教学规划不再愁</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-fense">
            <img src="../../assets/aiicon/aicon (3).png" alt="师幼互动提间导师" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">师幼互动提间导师</h3>
              <p class="card-desc">引导老师学习使用布鲁姆提问法科学提问</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
          <div class="category-card bg-yellow">
            <img src="../../assets/aiicon/aicon (4).png" alt="课题/论文大纲" class="card-icon">
            <div class="card-content">
              <h3 class="card-title">课题/论文大纲</h3>
              <p class="card-desc">根据研究方向等要求生成课题论文大纲</p>
              <div class="times">1点/次会话</div>
            </div>
          </div>
        </div>
      </div> -->

      <div v-if="recommendList.length > 0 && activeTab === -1 && searchText === ''" class="category-section">
        <h2 class="category-title blue">推荐</h2>
        <div class="category-cards">
          <div class="category-card" @click="toCoze(aiItem.bot_id)"  :style="{backgroundColor: aiItem.bg_color}" v-for="aiItem in recommendList" :key="aiItem.id">
            <img :src="aiItem.icon"  class="card-icon" >
            <div class="card-content">
              <h3 class="card-title">{{ aiItem.name }}</h3>
              <p class="card-desc">{{ aiItem.info }}</p>
              <div class="times">{{ aiItem.single_deduction +'点/次会话' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="searchText" class="category-section">
        <h2 class="category-title blue">搜索结果</h2>
        <div class="category-cards">
          <div class="category-card" @click="toCoze(aiItem.bot_id)"  :style="{backgroundColor: aiItem.bg_color}" v-for="aiItem in searchList" :key="aiItem.id">
            <img :src="aiItem.icon"  class="card-icon" >
            <div class="card-content">
              <h3 class="card-title">{{ aiItem.name }}</h3>
              <p class="card-desc">{{ aiItem.info }}</p>
              <div class="times">{{ aiItem.single_deduction +'点/次会话' }}</div>
            </div>
          </div>
        </div>
        <a-empty v-if="searchList.length === 0" description="暂无搜索结果"></a-empty>
      </div>
      
      <div v-else>
      <div  v-for="(item,index) in classList" v-show="activeTab === index || activeTab === -1" :key="index" class="category-section">
        <h2 class="category-title" :class="item.color">{{ item.name }}</h2>
        <div class="category-cards">
          <div class="category-card" @click="toCoze(aiItem.bot_id)"  :style="{backgroundColor: aiItem.bg_color}" v-for="aiItem in item.aiList" :key="aiItem.id">
            <img :src="aiItem.icon"  class="card-icon" >
            <div class="card-content">
              <h3 class="card-title">{{ aiItem.name }}</h3>
              <p class="card-desc">{{ aiItem.info }}</p>
              <div class="times">{{ aiItem.single_deduction +'点/次会话' }}</div>
            </div>
          </div>
        </div>
      </div>
      </div>
      

      <coze v-if="cozeId" :id="cozeId"></coze>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { aiApi } from '../../api/api-director';
import { mapState } from 'vuex';
import coze from './coze.vue';

export default {
  name: 'ai-help',
  data() {
    return {
      title: 'AI助手',
      activeTab: -1,
      classList: [],
      cozeId: '',
      searchList: [],
      searchText: '',
      recommendList: [],
    }
  },
  computed: {
    ...mapState(['userInfo','headers'])
  },
  components: {
    coze,
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getClassList()
        }
      },
      deep: true
    }
  },
  methods: {
    searchAI() {
      if (this.searchText) {
        this.searchList = this.classList.flatMap(item => item.aiList.filter(aiItem => aiItem.name.includes(this.searchText)))
        console.log(this.searchList)
      } else {
        this.searchList = []
      }
    },
    toCoze(id) {
      this.cozeId = ''
      setTimeout(() => {
       this.cozeId = id
      }, 200);
    },
    getClassList() {
      this.recommendList = []
      axios.post(aiApi.main + aiApi.getAIclassList).then(res => {
        if (res.data.result) {
          this.classList = res.data.data
          this.classList.forEach((item,index) => {
            switch (index) {
              case 0:
                item.color = 'blue'
                item.bgColor = 'bg-blue'
                break;
              case 1:
                item.color = 'green'
                item.bgColor = 'bg-green'
                break;
              case 2:
                item.color = 'green-light'
                item.bgColor = 'bg-green-light'
                break;

              case 3:
                item.color = 'green-light'
                item.bgColor = 'bg-blue-light'
                break;
              case 4:
                item.color = 'fense'
                item.bgColor = 'bg-fense'
                break;
              case 5:
                item.color = 'yellow'
                item.bgColor = 'bg-yellow'
                break;
            }
            this.getAIList(index)
          })
        }
      })
    },
    getAIList(index) {
      const classItem = this.classList[index]
      axios({
        url: aiApi.main + aiApi.getAIList,
        params: {
          currentPage: 1,
          pageSize: 100,
          class_id: classItem.id,
          user_id: this.userInfo?.id || '',
          school_id: this.userInfo?.school_id || '',
        } ,
        method: 'Get',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.headers,
        }
      }).then(res => {
        if (res.data.result) {
          this.classList[index].aiList = res.data.data
          const recommends = res.data.data.filter(item => item.recommend)
          this.recommendList.push(...recommends)
          console.log(this.classList)
          this.$forceUpdate()
        }
      })
    }
  },
  created() {
    if (this.userInfo) {
      this.getClassList()
    }
  }
}
</script>

<style scoped lang="scss">

  ol li ,ul li {
    font-size: 14px!important;
  }
/* 基础样式 */
.ai-help-container {
  background-color: #fff;
  padding-bottom: 40px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

/* 容器样式 - 最大宽度1100px，左右居中 */
.container {
  max-width: 1100px;
  margin: 0 auto;
}

/* 顶部导航栏 */
.ai-header {
  height: 60px;
  background-color: #ffffff;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.back-icon {
  width: 20px;
  height: 20px;
  margin-right: 15px;
  cursor: pointer;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

/* 欢迎区域 */
.welcome-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  margin: 20px auto;
  border-radius: 8px;
}

.ai-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 20px;
}

.welcome-text h2 {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 5px 0;
}

.welcome-text p {
  font-size: 14px;
  color: #666666;
  margin: 0;
}

/* 主要功能区域 */
.main-functions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows:110px 110px;
  margin-bottom: 30px;
  gap: 15px;
}

/* 推荐区域样式 */
.recommend-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 0;
  margin-bottom: 20px;
}

.nav-tabs {
  display: flex;
  gap: 10px;
}

.tab-item {
  font-size: 14px;
  color: #444;
  cursor: pointer;
  padding: 4px 10px;
  position: relative;
}

.tab-item:hover,
.tab-item.active {
  background: #67b0db;
  color: #fff;
  border-radius: 4px;
}


.search-box {
  position: relative;
}

.search-box input {
  width: 200px;
  height: 36px;
  padding: 0 35px 0 15px;
  border: 1px solid #ddd;
  border-radius: 18px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: #67b0db;
  }
}

.search-box::after {
  content: '\e625';
  font-family: 'iconfont';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 16px;
}

.function-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  position: relative;
  grid-row: 1/3;
  &:nth-child(2) {
    grid-column: 2/3;
    grid-row: 1/2;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    img {
      margin-right: 10px;
    }
  }
  &:nth-child(3) {
    grid-column: 2/3;
    grid-row: 2/3;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    img {
      margin-right: 10px;
    }
  }

  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
}

.function-icon {
  width: 54px;
  height: 54px;
  margin-bottom: 8px;
  object-fit: contain;
}

.function-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 0px;
}

.function-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.4;
}

.start-btn {
  background-color: #fff;
  color: #101010;
  border: none;
  border-radius: 100px;
  padding: 12px 12px;
  font-size: 16px;
  width: 160px;
  font-weight: bold;
  cursor: pointer;
}

/* 分类功能区域 */
.category-section {
  max-width: 1100px;
  margin: 0 auto 30px auto;
}

.category-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 15px 18px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
    bottom: 3px;
    width: 5px;
    border-radius: 10px;
    height: 18px;
    background-color: #67d0db;
  }
  &.green::before {
    background-color: #c3ddc0;
  }
  &.green-light::before {
    background-color: #f8bfab;
  }
  &.fense::before {
    background-color: #f2a1a8;
  }
  &.yellow::before {
    background-color: #fbd395;
  }
  &.blue-light::before {
    background-color: #c4d3b7;
  }
}

.bg-blue {
  background-color: #e1f3fd!important;
}

.bg-green {
  background-color: #f4f8e7!important;
}

.bg-green-light {
  background-color: #fff6ef!important;
}

.bg-blue-light {
  background-color: #f3f2f8!important;
}

.bg-fense {
  background-color: #fff7fa!important;
}

.bg-yellow {
  background-color: #ffffeb!important;
}

.category-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  flex-wrap: wrap;
  gap: 15px;
}

.category-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 20px 35px 20px;
  display: flex;
  align-items: flex-start;
  position: relative;
  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
}

.card-icon {
  width: 46px;
  height: 46px;
  margin-right: 15px;
  object-fit: contain;
  flex-shrink: 0;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  margin: 0 0 6px 0;
}

.card-desc {
  font-size: 12px;
  color: #444444;
  margin: 0 0 10px 0;
  line-height: 1.4;
}

.times {
  font-size: 12px;
  color: #555;
  margin-top: 10px;
  text-align: right;
  position: absolute;
  right: 20px;
  bottom: 16px;
}

/* 响应式设计 */
@media (max-width: 1140px) {
  .main-functions {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .function-card {
    flex: 1;
    min-width: 220px;
  }
  
  .category-card {
    flex: 1;
    min-width: 220px;
  }
}

@media (max-width: 768px) {
  .welcome-section {
    flex-direction: column;
    text-align: center;
  }
  
  .ai-avatar {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>